import { Component, OnInit, Input, Optional, ViewChild, ElementRef, NgZone, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators, FormGroup, AbstractControl, ControlContainer, FormGroupDirective } from '@angular/forms';
import { ErrorMassageValidation } from '../../Shared/services/validationErrorMassage.service';
import { UtilityService } from '../../Shared/services/UtilityService';
import { ControlUtility } from '../../Shared/services/ControlUtility';
import { FileUploader, FileDropDirective, FileLikeObject, FileItem } from 'ng2-file-upload';
import { FileDTO } from '../../Shared/Models/FileDTO';
import { CropperComponent } from 'angular-cropperjs';
import { ProfileImageUploadOptions } from '../../Shared/Models/ProfileImageUploadOptions';
import { ProfilePictureDTO } from '../../Shared/Models/ProfilePictureDTO';


@Component({
  selector: 'BBSF-ProfileImageUploader',
  templateUrl: './ProfileImageUploader.component.html',
  styleUrls: ['./ProfileImageUploader.component.scss']
})
export class ProfileImageUploaderComponent implements OnInit {

  static controlContainerstatic = null;

  @ViewChild('fileInput', {static:true,read:null}) fileInput: ElementRef;
  files: File[] = [];
  ImageSource: string = "https://ga.bnsights.com/Assets/Images/no-img.png"
  isSubmitted: boolean;
  @Input() group: FormGroup;
  @Input() options: ProfileImageUploadOptions;
  @Output() OnChange = new EventEmitter();
  ProfileImageUploadFormControl: AbstractControl;
  ValidationMessage = ""
  uploader: FileUploader;
  hasAnotherDropZoneOver: boolean;
  AcceptedType: string = "";
  AcceptedTypeArray: string[] = [];
  ToolTipTypeArray: string[] = [];
  FileLikeObject: FileLikeObject;
  ProfilePictureDTO: ProfilePictureDTO
  control: FormControl;
  markAllAsTouched: boolean = false;


  @ViewChild('angularCropper', {static:true,read:null}) public angularCropper: CropperComponent;
  imgUrl = null;
  config = null;
  imageUrl = ""
  imgwUrl = ""
  EventFile: any;
  mdlSampleIsOpen: boolean = false;
  validationRules = [];
  validationRulesasync = [];

  constructor(private zone: NgZone, private ErrorHandler: ErrorMassageValidation, private controlUtility: ControlUtility, @Optional() private controlContainer: ControlContainer, public ProfileImageUploaderControlHost: FormGroupDirective) {
    ProfileImageUploaderComponent.controlContainerstatic = this.controlContainer;
    this.uploader = new FileUploader({
      disableMultipart: false, // 'DisableMultipart' must be 'true' for formatDataFunction to be called.
    });
    this.hasAnotherDropZoneOver = false;
    this.ProfilePictureDTO = new ProfilePictureDTO();
  }

  ngOnInit() {
    UtilityService.isCreatedBefor = false

    if (this.options.DefaultImageSrc != null && this.options.DefaultImageSrc != "")
      this.ImageSource = this.options.DefaultImageSrc

    this.config = {
      aspectRatio: 200 / 200,
      dragMode: 'move',
      background: true,
      movable: true,
      rotatable: true,
      scalable: true,
      zoomable: true,
      viewMode: 1,
      checkImageOrigin: true,
      modal: true,
      checkCrossOrigin: false,
      cropBoxResizable: false,
      autoCrop: true


    }

    if (this.options.ImageUploadAcceptsTypes != null) {
      this.options.ImageUploadAcceptsTypes
    }


    if (this.options.LabelKey != null && this.options.LabelKey != "")
      this.options.LabelValue = UtilityService.getResourceValue(this.options.LabelKey);

    if (this.options.ImageUploadAcceptsTypes != null && this.options.ImageUploadAcceptsTypes.length > 0) {
      for (let index = 0; index < this.options.ImageUploadAcceptsTypes.length; index++) {
        const Type = this.options.ImageUploadAcceptsTypes[index];
        this.AcceptedType = this.AcceptedType + Type + ","
      }
      this.AcceptedTypeArray = this.AcceptedType.split(",")
      for (let index = 0; index < this.AcceptedTypeArray.length; index++) {
        const element = this.AcceptedTypeArray[index];
        const TypeToolTipe = element.split('/')[1];
        this.ToolTipTypeArray.push(TypeToolTipe);
      }
      this.ValidationMessage = this.ValidationMessage + ` Allowed extenstions (${this.ToolTipTypeArray}) `

    }
    if (this.options.FileMaxSizeInMB > 0) {
      this.ValidationMessage = this.ValidationMessage + ` <br />Max File Size ${this.options.FileMaxSizeInMB} MB`
    }
    if (this.options.ImageUploadAcceptsTypes != null && this.options.ImageUploadAcceptsTypes.length > 0) {
    }
    this.group.addControl(this.options.Name, new FormControl(''));
    this.ProfileImageUploadFormControl = this.group.controls[this.options.Name]; //  new FormControl('',validationRules);

    if (this.options.CustomValidation.length > 0) {
      let Validations = this.options.CustomValidation
      for (let index = 0; index < Validations.length; index++) {
        const Validation = Validations[index];
        this.validationRules.push(Validation.functionBody);
      }

    }


    if (this.options.IsRequired) {
      this.validationRules.push(Validators.required);
    }

    this.ProfileImageUploadFormControl.setValidators(this.validationRules);
    this.ProfileImageUploadFormControl.setAsyncValidators(this.validationRulesasync);
    if (this.options.IsDisabled) {
      this.ProfileImageUploadFormControl.disable();
    }

    this.ProfileImageUploaderControlHost.ngSubmit.subscribe((value) => {
      this.group.markAllAsTouched()
      this.markAllAsTouched = true
    })
  }

  ngAfterViewInit(): void {
    if (this.options.AttributeList != null) {
      var element = document.getElementById(this.options.Name);
      for (let index = 0; index < this.options.AttributeList.length; index++) {
        element.setAttribute(this.options.AttributeList[index].Key, this.options.AttributeList[index].value);
      }

    }

  }


  resetError = () => {
    UtilityService.RemoveGlobalError();
  }

  showGlobalError() {
    this.controlUtility.showGlobalError()
  }

  getErrorValidation(ErrorList) {
    if (this.markAllAsTouched && this.group.invalid) {
      this.showGlobalError()
      this.markAllAsTouched = false
    }

    return this.controlUtility.getErrorValidationMassage(ErrorList, this.group, this.options);
  }



  onFileChange(event) {
    if (event.rejectedFiles.length > 0) {
      const file = event.rejectedFiles[0];
      const maxFileSize = this.options.FileMaxSizeInMB * 1000 * 1000;
      const fileType = file.type;
      if (file.size > maxFileSize) {
        const formControl = this.ProfileImageUploadFormControl;
        formControl.setErrors({ FileMaxSizeInMB: this.options.FileMaxSizeInMB + 'M' });
        formControl.markAsTouched();
        this.uploader.queue = [];
        return;
      }
      if (this.options.ImageUploadAcceptsTypes != null && this.options.ImageUploadAcceptsTypes.length > 0 && !(this.AcceptedTypeArray.includes(fileType.toUpperCase()) || this.AcceptedTypeArray.includes(fileType.toLowerCase()))) {
        const formControl = this.ProfileImageUploadFormControl;
        formControl.setErrors({ ToolTipTypeError: this.ToolTipTypeArray });
        formControl.markAsTouched();
        this.uploader.queue = [];
        return;
      }
    }
    let FilesArray = [];
    for (let index = 0; index < event.addedFiles.length; index++) {
      const file = event.addedFiles[0];
      this.EventFile = file;
      const maxFileSize = this.options.FileMaxSizeInMB * 1000 * 1000;
      if (file) {
        const maxFileSize = this.options.FileMaxSizeInMB * 1000 * 1000;
        const fileType = file.type;
        if (file.size > maxFileSize) {
          const formControl = this.ProfileImageUploadFormControl;
          formControl.setErrors({ FileMaxSizeInMB: this.options.FileMaxSizeInMB + 'M' });
          formControl.markAsTouched();
          this.uploader.queue = [];
          return;
        }
        let reader = new FileReader();
        let FileObject = file;
        reader.readAsDataURL(FileObject);
        reader.onload = () => {
          this.imageUrl = reader.result.toString();
          this.openModal(true);
          this.OnChange.emit(this.group.get(this.options.Name).value)
        };
      }
    }
  }
  removeFromControlValue(event) {
    let ItemList = this.group.get(this.options.Name).value;
    this.files.splice(this.files.indexOf(event), 1);
    ItemList = [];
    if ((this.files.length == 0) && this.options.IsRequired) {
      this.ProfileImageUploadFormControl.markAsTouched();
      this.ProfileImageUploadFormControl.setErrors(Validators.required);
      this.ProfileImageUploadFormControl.invalid;
    }
    this.group.get(this.options.Name).setValue(ItemList);
    this.OnChange.emit(this.group.get(this.options.Name).value)

  }
  cropImage() {
    this.ProfilePictureDTO.FileName = this.EventFile.name;
    this.ProfilePictureDTO.Original = this.EventFile.name + "Original";
    this.ProfilePictureDTO.MediumPicture = this.EventFile.name + "MediumPicture";
    this.ProfilePictureDTO.SmallPicture = this.EventFile.name + "SmallPicture";
    let Cropper = this.angularCropper.cropper;
    let profilePicturCropper = Cropper.getCroppedCanvas({
      width: 400,
      height: 400,
      imageSmoothingEnabled: false,
      imageSmoothingQuality: 'high',
    });
    let AvatarPictureCropper = Cropper.getCroppedCanvas({
      width: 100,
      height: 100,
      imageSmoothingEnabled: false,
      imageSmoothingQuality: 'high',
    });
    let OriginalPictureCropper = Cropper.getCroppedCanvas({
      width: 700,
      height: 700,
      imageSmoothingEnabled: false,
      imageSmoothingQuality: 'high',
    });
    profilePicturCropper.toBlob((blob) => {
      this.zone.run(() => {
        this.getProfileImageBlobFile(blob, "profilePicturCropper");
      });
    });
    AvatarPictureCropper.toBlob((blob) => {
      this.zone.run(() => {
        this.getProfileImageBlobFile(blob, "AvatarPictureCropper");
      });
    });
    OriginalPictureCropper.toBlob((blob) => {
      this.zone.run(() => {
        this.getProfileImageBlobFile(blob, "OriginalPictureCropper");
      });
    });

    this.files = [];

    this.openModal(false);
  }
  getProfileImageBlobFile(blob, type) {
    let FilesArray = [];
    let BlobFile;
    let reader = new FileReader();
    BlobFile = blob;
    reader.readAsDataURL(BlobFile);
    reader.onload = () => {
      let FileObject = new FileDTO();
      switch (type) {
        case "profilePicturCropper":
          BlobFile.name = this.EventFile.name + "MediumPicture";
          FileObject.FileName = this.EventFile.name + "MediumPicture";
          FileObject.FileType = this.EventFile.type;
          FileObject.FileBase64 = reader.result.toString().split(',')[1];
          FileObject.FileSizeInMB = ((BlobFile.size / 1000) / 1000);
          this.ProfilePictureDTO.profilePicture = FileObject;
          this.files.push(BlobFile);
          break;
        case "AvatarPictureCropper":
          FileObject.FileName = this.EventFile.name + "SmallPicture";
          FileObject.FileType = this.EventFile.type;
          FileObject.FileBase64 = reader.result.toString().split(',')[1];
          FileObject.FileSizeInMB = ((BlobFile.size / 1000) / 1000);
          this.ProfilePictureDTO.AvatarPicture = FileObject;
          break;

        case "OriginalPictureCropper":
          FileObject.FileName = this.EventFile.name + "Original";
          FileObject.FileType = this.EventFile.type;
          FileObject.FileBase64 = reader.result.toString().split(',')[1];
          FileObject.FileSizeInMB = ((BlobFile.size / 1000) / 1000);
          this.ProfilePictureDTO.OriginalPicture = FileObject;
          this.group.get(this.options.Name).setValue(this.ProfilePictureDTO);
          this.OnChange.emit(this.group.get(this.options.Name).value)

          break;
        default:
          break;
      }

    };
  }



  rotateImage(degree: number) {
    this.angularCropper.cropper.rotate(degree)
  }
  moveImage(offsetX: number, offsetY: number) {
    this.angularCropper.cropper.move(offsetX, offsetY)
  }
  zoomImage(ratio: number) {
    this.angularCropper.cropper.zoom(ratio)
  }


  openModal(open: boolean): void {
    this.mdlSampleIsOpen = open;
  }

  //External Method
  RemoveRequiredValidation = () => {
    this.controlUtility.RemoveRequiredValidation(this.ProfileImageUploadFormControl, this.validationRules, this.options)
  }
  //External Method
  AddRequiredValidation = () => {
    this.controlUtility.AddRequiredValidation(this.ProfileImageUploadFormControl, this.validationRules, this.options)
  }
  //External Method
  RemoveCustomValidation = (CustomValidation) => {
    this.controlUtility.RemoveCustomValidation(this.ProfileImageUploadFormControl, this.validationRules, CustomValidation)
  }
  //External Method
  AddCustomValidation = (CustomValidation) => {
    this.controlUtility.AddCustomValidation(this.ProfileImageUploadFormControl, this.validationRules, CustomValidation)
  }
  //External Method
  IsValid = () => {
    this.controlUtility.IsValid(this.ProfileImageUploadFormControl)
  }

}


